import * as api from "./api";
import * as modelsGet from "../models/get";

export function getActivities(eventId: number, orderAsc: boolean = false): JQueryPromise<modelsGet.IActivity[]>
{
    var endpoint = new URI("api/activities");
    endpoint.segment(eventId.toString());
    endpoint.setQuery("orderAsc", ((orderAsc) ? "true" : "false"))

    return api.get<modelsGet.IActivity[]>({
        endpoint: endpoint.href()
    });
}

export function getLastActivity(eventId: number): JQueryPromise<modelsGet.ILastActivity>
{
    var endpoint = new URI("api/activities/last");
    endpoint.segment(eventId.toString());

    return api.get<modelsGet.ILastActivity>({
        endpoint: endpoint.href()
    });
}